import { Button, Typography } from "@material-ui/core"
import { Blog as BlogType } from "api"
import NextLink from "common/bit/NextLink"
import { useInView } from "react-intersection-observer"
import styled from "styled-components"
import { HomePageContainer } from "theme/shared"
import BlogCard from "./BlogCard"

const StyledWrapperContainer = styled(HomePageContainer)<{ $inView: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 80px 20px;
  ${(p) => p.theme.breakpoints.up("md")} {
    padding: 62px 60px;
    transition: all 0.9s 0.9s cubic-bezier(0.19, 0.88, 0.53, 1.12);
    transform: ${({ $inView }) =>
      $inView ? "translate3d(0, 0, 0)" : "translate3d(0, -85px, 0)"};
    opacity: ${({ $inView }) => ($inView ? "1" : "0")};
    transition-delay: 0.3s;
  }
`
const StyledTitle = styled(Typography).attrs({
  variant: "h1",
  component: "h2",
})`
  align-items: center;
`
const StyledCardWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 80px;
  margin: 80px 0px;
  ${(p) => p.theme.breakpoints.up("md")} {
    flex-direction: row;
    margin: 60px 0px;

    justify-content: stretch;
  }
`
type BlogProps = {
  blogData: BlogType[]
}

const Blog = ({ blogData }: BlogProps) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
  })
  return (
    <div ref={ref}>
      {!!blogData?.length && (
        <StyledWrapperContainer $inView={inView}>
          <StyledTitle>ZoOM BLOG</StyledTitle>
          <StyledCardWrapper>
            {blogData?.map((item) => (
              <BlogCard inView={inView} key={item.id} blogDate={item} />
            ))}
          </StyledCardWrapper>
          <NextLink href="https://blog.mazda.co.il/" openInNewTab>
            <Button variant="outlined">לכלל הכתבות</Button>
          </NextLink>
        </StyledWrapperContainer>
      )}
    </div>
  )
}

export default Blog
